import React from "react";
import Carousel from "react-multi-carousel";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import bgSidebar from "../../assets/images/bg_sidebar.png";
import CarouselBody from "../CarouselBody/CarouselBody";
import { Images } from "../../settings/paths";
import { COLORS } from "../../lib/styles/styles";

const LandingWrapper = styled.div`
	${tw`m-0 p-0 bg-white flex flex-row flex-wrap overscroll-none`}

	.landing-sidebar {
		${tw`h-screen w-full p-8`}
		flex: 1;
		background: url(${bgSidebar});
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		background-blend-mode: darken;
	}

	.landing-carousel {
		${tw`h-screen w-1/2 p-0 m-0 bg-gradient-to-t from-gray-400 via-red-300 to-gray-400 relative bg-blend-darken`}
		flex: 1;
		@media (max-width: 768px) {
			display: none;
		}

		.carousel-container {
			${tw`h-screen w-full p-0 m-0`}

			.custom-dot-list-style {
				margin-bottom: 3rem;
				border: none;
			}

			.react-multi-carousel-dot {
				border-color: none !important;
				button {
					border-color: none !important;
					background: ${COLORS.appGentleGray};
					opacity: 0.7;
				}
			}

			.react-multi-carousel-dot--active {
				border-color: none !important;
				button {
					opacity: 1;
					background: #ffffff;
				}
			}
		}
	}
`;

const LandingLayout = (props) => {
	const responsive = {
		desktop: {
			breakpoint: { max: 3000, min: 768 },
			items: 1,
			slidesToSlide: 1, // optional, default to 1.
		},
	};
	return (
		<LandingWrapper className={props.className}>
			<div className="landing-sidebar">{props.children}</div>
			<div className="landing-carousel">
				<Carousel
					swipeable={false}
					draggable={false}
					arrows={false}
					showDots={true}
					responsive={responsive}
					infinite={true}
					autoPlay={true}
					autoPlaySpeed={10000}
					customTransition="all .5"
					transitionDuration={500}
					containerClass="carousel-container"
					dotListClass="custom-dot-list-style"
					itemClass="carousel-item-padding-40-px"
				>
					{Images?.map((img, index) => {
						return (
							<CarouselBody
								key={index}
								src={img.src}
								text1={img.text1}
								text2={img.text2}
							/>
						);
					})}
				</Carousel>
			</div>
		</LandingWrapper>
	);
};

export default LandingLayout;
